import React from "react";

class SocialLinks extends React.Component {
  render() {
    return (
      <ul className="social-links">
        {/* Full list of social icons: http://fontawesome.io/icons/#brand */}
        <li>
          <a
            className="tip social-button"
            href="https://www.linkedin.com/in/muneeb-shahid-87b825117/"
            target="_blank"
            rel="noopener noreferrer"
            title="LinkedIn"
          >
            <i className="fa fa-linkedin" />
          </a>
        </li>
        <li>
          <a
            className="tip social-button"
            href="https://github.com/muneeb706"
            target="_blank"
            rel="noopener noreferrer"
            title="GitHub"
          >
            <i className="fa fa-github" />
          </a>
        </li>
        <li>
          <a
            className="tip social-button"
            href="https://stackoverflow.com/users/5891351/muneeb-shahid?tab=profile"
            target="_blank"
            rel="noopener noreferrer"
            title="Stack Overflow"
          >
            <i className="fa fa-stack-overflow" />
          </a>
        </li>
        <li>
          <a
            className="tip social-button"
            href="https://muneebshahid.com/"
            target="_blank"
            rel="noopener noreferrer"
            title="My Blogging Website"
          >
            <i className="fa fa-book" />
          </a>
        </li>
        {/*<li><a class="tip social-button" href="#" title="Youtube"><i class="fa fa-youtube"></i></a></li>*/}
        {/*<li><a class="tip social-button" href="#" title="last.fm"><i class="fa fa-lastfm"></i></a></li>*/}
        {/*<li><a class="tip social-button" href="#" title="Dribbble"><i class="fa fa-dribbble"></i></a></li>*/}
      </ul>
    );
  }
}

export default SocialLinks;
